import {
  PaymentListActionTypes,
  PAYMENT_LIST_FAIL,
  PAYMENT_LIST_LOADING,
  PAYMENT_LIST_SUCCESS,
  PaymentListState,
  PAYMENT_LIST_API_MSG,
  PAYMENT_LIST_API_RES,
} from "./ActionTypes";
import { PaymentListResponse } from "./Model";

const initialStateEditPosts: PaymentListState = {
  loading: false,
  paymentListResponse: {} as PaymentListResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const paymentListReducer = (
  state = initialStateEditPosts,
  action: PaymentListActionTypes
): PaymentListState => {
  switch (action.type) {
    case PAYMENT_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case PAYMENT_LIST_SUCCESS:
      return {
        ...state,
        paymentListResponse: action.payload,
        successMsg: action.successMsg,
      };
    case PAYMENT_LIST_FAIL:
      return {
        ...state,
        paymentListResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case PAYMENT_LIST_API_MSG:
      return {
        ...state,
        paymentListResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case PAYMENT_LIST_API_RES:
      return {
        ...state,
        paymentListResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
